
<mat-dialog-content  [ngStyle]="{'text-align': messages.length > 1 ? 'left' : 'center' }" >
  <h3 style="font-weight: 600;font-size:1.1vw;" *ngIf="data.header_msg" >{{data.header_msg}}</h3>
  <p style="font-weight: 500;font-size:1vw;margin-top:20px;"*ngFor="let msg of messages" >{{msg}}</p>
</mat-dialog-content>
<mat-dialog-actions align="end" style="font-size:0.95vw;font-weight: 500;">
  <button mat-flat-button mat-dialog-close>{{data.cancel_action}}</button>
  <button mat-raised-button color="warn" [mat-dialog-close]="true" cdkFocusInitial>{{data.ok_action}}</button>
</mat-dialog-actions>
